export const LEGALPERMISSION_LOADING = "LEGALPERMISSION_LOADING";
export const LEGALPERMISSION_RESET = "LEGALPERMISSION_RESET";
export const GET_LEGALPERMISSION = "GET_LEGALPERMISSION";
export const GET_LEGALPERMISSION_SUCCESS = "GET_LEGALPERMISSION_SUCCESS";
export const GET_LEGALPERMISSION_FAIL = "GET_LEGALPERMISSION_FAIL";
export const DELETE_LEGALPERMISSION = "DELETE_LEGALPERMISSION"
export const DELETE_LEGALPERMISSION_SUCCESS = "DELETE_LEGALPERMISSION_SUCCESS"
export const DELETE_LEGALPERMISSION_FAIL = "DELETE_LEGALPERMISSION_FAIL"
export const UPDATE_LEGALPERMISSION = "UPDATE_LEGALPERMISSION"
export const UPDATE_LEGALPERMISSION_SUCCESS = "UPDATE_LEGALPERMISSION_SUCCESS"
export const UPDATE_LEGALPERMISSION_FAIL = "UPDATE_LEGALPERMISSION_FAIL"
export const ADD_NEW_LEGALPERMISSION = "ADD_NEW_LEGALPERMISSION"
export const ADD_LEGALPERMISSION_SUCCESS = "ADD_LEGALPERMISSION_SUCCESS"
export const ADD_LEGALPERMISSION_FAIL = "ADD_LEGALPERMISSION_FAIL"